import {
  FormViewServiceProvider,
  vsProviderName as FormViewServiceProviderName,
} from "../../../../records/forms/formView";
import {
  registerContractAmendmentConfig,
} from "./../../../../Contract/shared/configs/contractAmendment";

export const vsObjectName = "gamingContractMasterAgreementAmendment";

GamingContractMasterAgreementAmendmentConfig.$inject = [
  FormViewServiceProviderName,
];

export function GamingContractMasterAgreementAmendmentConfig(
  formViewServiceProvider: FormViewServiceProvider
) {
  registerContractAmendmentConfig(formViewServiceProvider, {
    objectName: vsObjectName,
    title: "Master Agreement Amendment",
  });
}